import React from "react";
import flowLogoFull from "./Assets/FLOW LOGO/FILLED CLEAN VECTOR.svg";
import flowLogoIcon from "./Assets/FLOW LOGO/FILLED CLEAN VECTOR ICON.svg";

export default function FlowLogo({ compact = false, centered = false, showTagline = true, className = "" }) {
  const classes = [
    "flow-lockup",
    compact ? "flow-lockup--compact" : "flow-lockup--full",
    centered ? "flow-lockup--centered" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (compact) {
    return (
      <div className={classes} aria-label="FLOW by RAEM">
        <img className="flow-lockup__icon" src={flowLogoIcon} alt="FLOW icon" />
        <div className="flow-lockup__compact-copy">
          <span className="flow-lockup__title">FLOW</span>
          <span className="flow-lockup__subtitle">BY RAEM</span>
        </div>
      </div>
    );
  }

  return (
    <div className={classes} aria-label="FLOW by RAEM">
      <div className="flow-lockup__stack">
        <img className="flow-lockup__full-image" src={flowLogoFull} alt="FLOW by RAEM" />
        {showTagline ? (
          <span className="flow-lockup__tag">Financial clarity for the month you are actually living.</span>
        ) : null}
      </div>
    </div>
  );
}
